import { render } from "./EventButton.vue?vue&type=template&id=6b7265ac&ts=true"
import script from "./EventButton.vue?vue&type=script&lang=ts"
export * from "./EventButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__